import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { HeaderService } from '../header/header.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(private router: Router, private headerService: HeaderService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean | UrlTree {
    let data = this.headerService.isLogin;
    if (data) {
      return true;
    }
    else {
      sessionStorage.clear()
      localStorage.clear();
      this.router.navigateByUrl("/Login");
      return false;
    }
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean | UrlTree {
    let data = this.headerService.isLogin;
    if (data) {
      return true;
    }
    else {
      sessionStorage.clear()
      localStorage.clear();
      this.router.navigateByUrl("/Login");
      return false;
    }
  }
}


